import React from 'react';
//react-redux comm
import {  } from '../../_actions';

import ViewHeader from './view-header';
import ViewContent from './view-content';
// styling
import './style.css';



class DomesticInvoicePayment extends React.Component {
    render() {
        return (
            <div className="view">
            <ViewHeader/>
            <ViewContent/>
        </div>
        )
    }

}



export default DomesticInvoicePayment;


// WEBPACK FOOTER //
// ./src/views/unmatched-domestic-payment/index.js